import { FacultyType } from "../../../types/Faculty";
import { put } from "../../../utils/axios-config";
import { FACULTIES } from "../../../utils/constants";

export const updateFaculty = async (data:FacultyType) => {
    return await put<FacultyType, string>(FACULTIES, data);
};